import React from "react";
import styles from "./cp-table-action-bar.styles.css";

type CpTableActionBarProps = {
  className?: string;
  children?: React.ReactNode;
};

export function CpTableActionBar({
  className,
  children,
}: CpTableActionBarProps) {
  return (
    <div className={`${styles.actionBar} ${className || ""}`}>{children}</div>
  );
}
